import { motion } from "framer-motion";
import video from "@/assets/videos/313224_medium.mp4";
import { ArrowRight, Download } from "lucide-react";


import { useNavigate } from "react-router-dom";

export default function Hero() {
  const navigate=useNavigate();
  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* Video Background */}
      <div className="absolute inset-0 bg-linear-to-br from-gray-600 via-gray-700 to-gray-800">
        <video
          className="w-full h-full object-cover opacity-60"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src={video} type="video/mp4" />
        </video>
      </div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-black/40" />

      {/* Content */}
      <div className="relative h-full flex items-center justify-center px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-5xl mx-auto">
          {/* Heading animation (from bottom) */}
          <motion.h1
            className="text-4xl sm:text-6xl lg:text-7xl text-white mb-6 leading-tight font-pacifico"
            initial={{ y: 80, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{
              duration: 1,
              ease: "easeOut",
            }}
          >
            Your Smart Way to Order Food, Groceries & Save More
          </motion.h1>

          {/* Paragraph animation (from right) */}
          <motion.p
            className="text-xl sm:text-2xl lg:text-3xl text-white/95 font-light max-w-3xl mx-auto leading-relaxed"
            initial={{ x: 80, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{
              duration: 1.2,
              ease: "easeOut",
              delay: 0.3,
            }}
          >
            Everything you need, from fresh meals and groceries to exclusive
            Mystery Bags - All in one place.
          </motion.p>
          <div className="mt-8 flex flex-col items-center gap-6">
            <button
              className="group relative px-8 py-4 rounded-2xl font-bold text-lg whitespace-nowrap shadow-2xl backdrop-blur-xl bg-white/10 border border-white/20 text-white transform hover:-translate-y-1 transition-all duration-500 overflow-hidden w-64"
              onClick={() => navigate("/login-choice")}
            >
              <span className="relative z-10 flex items-center justify-center gap-3">
                Login
                <ArrowRight className="w-6 h-6 group-hover:translate-x-2 transition-transform duration-300" />
              </span>

              {/* Glossy overlay effect */}
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 bg-linear-to-r from-transparent via-white/10 to-transparent skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-1000" />

              {/* Glow effect */}
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-green-500/10 blur-xl -z-10" />
            </button>

            <button
              className="group relative px-8 py-4 rounded-2xl font-bold text-lg whitespace-nowrap shadow-2xl backdrop-blur-xl bg-white/10 border border-white/20 text-white transform hover:-translate-y-1 transition-all duration-500 overflow-hidden w-64"
              // onClick={() => navigate("/download-app")}
            >
              <span className="relative z-10 flex items-center justify-center gap-3">
                Download App
                <Download className="w-6 h-6 group-hover:translate-y-1 transition-transform duration-300" />
              </span>

              {/* Glossy overlay effect */}
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 bg-linear-to-r from-transparent via-white/10 to-transparent skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-1000" />

              {/* Glow effect */}
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-blue-500/10 blur-xl -z-10" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
